import { Http, Headers, URLSearchParams, RequestOptions } from "@angular/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { Mappings } from '../../shared/mapping';
import { HttpParam } from "./../../models/core/http-param";

@Injectable()
export class OrderPaymentService 
{
        
    constructor
    (
        public _api: ApiService, 
        public _cache: CacheService,
        private mappings: Mappings
    ){}

    setOrderAsPayed(orderId) 
    {
        let url = this.mappings.Web_Api_Set_Order_As_Payed;

        let orderID = 
        {
            OrderId:parseInt(orderId)
        }

        return this._api.post(url,orderID);
    }

    CheckIsOrderPayedUnicredit(orderId) 
    {
        let url = this.mappings.Web_Api_Check_Is_Order_Payed_Unicredit.replace('{orderId}', orderId.toString());
        return this._api.post(url);
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/order-payment.service.ts